import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "fileInput",
    "form",
    "dropzone",
    "previewArea",
    "previewImage",
    "fileName",
    "fileSize",
  ];

  fileSelected() {
    const file = this.fileInputTarget.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      this.previewImageTarget.src = e.target.result;
    };
    reader.readAsDataURL(file);

    this.fileNameTarget.textContent = file.name;
    this.fileSizeTarget.textContent = this._formatSize(file.size);

    this.dropzoneTarget.classList.add("hidden");
    this.previewAreaTarget.classList.remove("hidden");
  }

  openFilePicker(event) {
    event.preventDefault();
    this.fileInputTarget.click();
  }

  dragover(event) {
    event.preventDefault();
    this.dropzoneTarget
      .querySelector("[data-action]")
      ?.classList.add("bg-brand-50/50", "border-brand-400");
  }

  dragleave(event) {
    event.preventDefault();
    this.dropzoneTarget
      .querySelector("[data-action]")
      ?.classList.remove("bg-brand-50/50", "border-brand-400");
  }

  drop(event) {
    event.preventDefault();
    this.dragleave(event);
    const files = event.dataTransfer.files;
    if (files.length > 0) {
      this.fileInputTarget.files = files;
      this.fileSelected();
    }
  }

  _formatSize(bytes) {
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  }
}
